import React from "react";

function Head(props) {
    return <head>
        <title>{props.pageTitle}</title>
    </head>
}

export default Head;